import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

const TILES = [
  { key: "total", label: "Total Cards" },
  { key: "unassigned", label: "Unassigned" },
  { key: "reserved", label: "Reserved" },
  { key: "active", label: "Active" },
  { key: "suspended", label: "Suspended" },
  { key: "retired", label: "Retired" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/cards/stats/summary").then((r) => setStats(r.data));
  }, []);

  return (
    <div data-testid="dashboard-page">
      <h1 className="text-2xl font-bold mb-1">Dashboard</h1>
      <p className="text-gray-500 mb-6 text-sm">Physical card inventory overview.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {TILES.map((t) => (
          <Card key={t.key} data-testid={`stat-${t.key}`}>
            <CardContent className="p-5">
              <div className="text-3xl font-bold">{stats ? stats[t.key] ?? 0 : "—"}</div>
              <div className="text-sm text-gray-500 mt-1">{t.label}</div>
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="mt-6">
        <Card>
          <CardContent className="p-5">
            <div className="text-sm text-gray-500">Registered Businesses</div>
            <div className="text-2xl font-bold mt-1" data-testid="stat-businesses">
              {stats ? stats.businesses ?? 0 : "—"}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
